<template>
  <div class="legend-control">
    <div>
      <table class="table table-responsive table-sm table-borderless">
        <tbody>
          <tr id="ip-row" v-if="status === '2' || status === null && !smpApproved">
            <td id="ip" class="symbol"></td>
            <td class="pl-2">{{ $t('legend.inprocess') }}</td>
          </tr>
          <tr id="fc-row" v-if="status === '0' || status === null && !smpApproved">
            <td id="fc" class="symbol"></td>
            <td class="pl-2">{{ $t('legend.granted') }}</td>
          </tr>
          <tr id="smp-row" v-if="smpApproved || status === '0' || status === null">
            <td id="smp" class="symbol"></td>
            <td class="pl-2">{{ $t('legend.smp') }}</td>
          </tr>
          <tr id="cmc-tr" v-if="mining">
            <td id="cmc" class="symbol"></td>
            <td class="pl-2">{{ $t('map.layers.mining') }}</td>
          </tr>
          <tr id="clc-tr" v-if="logging">
            <td id="clc" class="symbol"></td>
            <td class="pl-2">{{ $t('map.layers.logging') }}</td>
          </tr>
          <tr id="pa-tr" v-if="protectedAreas">
            <td id="pa" class="symbol"></td>
            <td class="pl-2">{{ $t('map.layers.protected-areas') }}</td>
          </tr>
          <tr id="ag-tr" v-if="agriculture">
            <td id="ag" class="symbol"></td>
            <td class="pl-2">{{ $t('map.layers.agriculture') }}</td>
          </tr>
          <tr id="db-tr" v-if="boundary">
            <td id="db" class="symbol">
              <svg width="20px" height="20px">
                <line x1="0" y1="10" x2="20" y2="10" />
              </svg>
            </td>
            <td class="pl-2">{{ $t('map.layers.boundary') }}</td>
          </tr>
          <tr id="dp-tr" v-if="provinces">
            <td id="dp" class="symbol">
              <svg width="20px" height="20px">
                <line x1="0" y1="10" x2="20" y2="10" />
              </svg>
            </td>
            <td class="pl-2">{{ $t('map.layers.provinces') }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    "provinces",
    "boundary",
    "mining",
    "logging",
    "protectedAreas",
    "agriculture",
    "status",
    "smp-approved"
  ]
};
</script>
<style scoped>
.legend-control {
  position: absolute;
  bottom: 25px;
  right: 10px;
  z-index: 800;
  background-color: #fff;
  padding: 1em;
  border: 1px solid #a61f5c;
  border-radius: 4px;
  font-size: 0.8rem;
  box-shadow: 4px 4px 4px #888888;
}

td.symbol {
  width: 20px;
  margin-right: 0.5rem;
}

.legend-control td#fc {
  background-color: #0ed029;
  border: 1px solid #0ed029;
}

.legend-control td#ip {
  background-color: #fb9b54;
  border: 1px solid #fb9b54;
}

.legend-control td#smp {
  background-color: #117f69;
  border: 1px solid #117f69;
}

.legend-control td#ns {
  background-color: #3130fb;
  border: 1px solid #3130fb;
}

.legend-control td#cmc {
  background-image: linear-gradient(
    135deg,
    rgba(236, 213, 137, 1) 25%,
    transparent 25%,
    transparent 50%,
    rgba(236, 213, 137, 1) 50%,
    rgba(236, 213, 137, 1) 75%,
    transparent 75%,
    transparent
  );
  background-size: 5px 5px;
  border: 1px solid rgb(236, 213, 137);
}

td#clc {
  background-color: #aaa29b;
  border: 1px solid #aaa29b;
}

td#pa {
  background-color: #8d9976;
  border: 1px solid #8d9976;
}

td#ag{
  background-color: #ECD589;
  border: 1px solid #ECD589;
}

td#dp > svg > line {
  /* stroke: rgb(255, 195, 0); */
  stroke: rgb(168, 0, 34);
  stroke-width: 2;
  stroke-dasharray: 10, 5;
}

td#db > svg > line {
  stroke: rgb(168, 0, 34);
  stroke-width: 2;
}

.legend-control td#db > hr {
  margin: 0;
  border-top: 3px solid rgb(168, 0, 34);
  padding: 0;
}

.legend-control td#dp > hr {
  margin: 0;
  border-top: 3px solid rgb(168, 0, 34);
  padding: 0;
}

.legend-control td#ter {
  background-color: #000;
}

.table-sm td {
  padding: 1px 1px 1px 1px;
  height: 20px !important;
}

table {
  margin-bottom: 0 !important;
}
</style>
